<template>
  <main
    class="flex sm:flex flex-col lg:grid grid-cols-12 gap-5 container mx-auto"
  >
    <CourseLearningMapStudent
      v-if="showMap && isAdaptativeLearning"
      @onCloseMap="studentMap"
    />
    <section class="col-span-12">
      <HeaderTeacherMaterials
        @onChooseMaterial="onChooseMaterial"
        @onDeleteObject="onDeleteObject"
        @onGoToEditObject="onGoToEditObject"
        v-if="
          typeModalHeader === _typeModalHeader.TEACHER ||
          typeModalHeader === _typeModalHeader.ADMINISTRATOR ||
          typeModalHeader === _typeModalHeader.TEACHER_TRADITIONAL_COURSE ||
          typeModalHeader === _typeModalHeader.TEACHER_LINEAR
        "
        :material="currentMaterial"
        :indexMaterial="indexMaterial"
        :maxIndexMaterial="maxIndexMaterial"
        :typeModalHeader="typeModalHeader"
        :isAdaptativeLearning="isAdaptativeLearning"
      />
      <HeaderLearningMapStudent
        @onChooseMaterial="onChooseMaterial"
        v-if="
          (typeModalHeader === 'STUDENT_LEARNING_MAP' ||
            typeModalHeader === 'STATS_LEARNING_MAP') &&
          isAdaptativeLearning
        "
        :material="currentMaterial"
        :indexMaterial="indexMaterial"
        :maxIndexMaterial="maxIndexMaterial"
        :typeModalHeader="typeModalHeader"
      />

      <Loader :loader="loader" />
      <div
        class="px-3 mt-4 flex items-center flex-col w-full"
        v-if="
          currentMaterial?.file?.url &&
          !loader &&
          materials[0]?.file?.status === 'DONE'
        "
        v-motion
        :initial="initialMotion"
        :enter="enterMotion"
      >
        <div
          v-if="typeModalHeader === 'STUDENT'"
          class="flex flex-col sm:flex-row w-full min-w-[360px] justify-start sm:justify-between items-start sm:items-center sticky top-0 p-3 bg-[#f8f9fa] rounded-sm gap-3 z-50"
        >
          <div class="flex items-center gap-4">
            <div class="flex items-center gap-5 w-fit">
              <h4>{{ currentMaterial?.name }}</h4>
              <div
                v-if="!isAdaptativeLearning && done"
                class="bg-green-500 text-green-50 px-3 py-1 rounded-lg border text-sm"
              >
                {{ $t("labels.generic", { pt: "Concluído", en: "Concluded" }) }}
              </div>
            </div>

            <div
              id="tips"
              v-if="!done && isVideo()"
              class="group w-fit flex !justify-start lg:!justify-center"
            >
              <i
                class="pi pi-exclamation-circle cursor-pointer text-white bg-h-warning-400 px-1 !text-xl rounded-full hover:scale-75 transition-all animate-bounce-short"
              />
              <div
                class="hidden absolute transition-all group-hover:flex group-focus:flex bg-white p-3 w-64 mt-8 rounded-lg !z-50 shadow-md border overflow-hidden break-words whitespace-normal"
              >
                <p
                  v-html="
                    'O material do tipo <b>vídeo só será considerado concluído</b>, se o aluno <b>assistir pelo menos 90%</b> de seu conteúdo.'
                  "
                ></p>
              </div>
            </div>
          </div>

          <div
            :class="[
              'w-full  flex justify-end items-center gap-5 z-50',
              isAdaptativeLearning ? 'sm:w-[50%]' : 'w-fit',
            ]"
          >
            <HistoryMaterials
              v-if="currentMaterial"
              :materials="materials"
              :currentMaterial="currentMaterial"
              :learningObjective="learningObjective"
              :isAdaptativeLearning="isAdaptativeLearning"
              @onChooseMaterial="(e) => onChooseMaterial(e)"
              @onCloseStudentMap="studentMap"
            />

            <div v-if="isAdaptativeLearning" class="flex items-center gap-2">
              <Button
                class="btn-primary p-button-sm"
                :disabled="isDisabledBackButton()"
                @click.prevent="onVerifyMaterials(-1)"
                icon="pi pi-chevron-left"
                title="`Voltar objeto de aprendizagem`"
              />

              <Button
                class="btn-primary p-button-sm"
                @click.prevent="onOpenFeedback('material')"
                :disabled="isDisableNextButton"
                icon="pi pi-chevron-right"
                title="`Próximo objeto de aprendizagem`"
              />
            </div>

            <div id="traditional" class="flex flex-col gap-2" v-else>
              <div class="flex items-center gap-2">
                <Button
                  class="btn-primary p-button-sm"
                  :disabled="isDisableBackButton"
                  @click.prevent="$emit('onBackMaterial')"
                  icon="pi pi-chevron-left"
                  title="`Voltar objeto de aprendizagem`"
                />

                <Button
                  class="btn-primary p-button-sm"
                  @click.prevent="onNextMaterial"
                  :disabled="isDisableNextButton"
                  icon="pi pi-chevron-right"
                  title="`Próximo objeto de aprendizagem`"
                />
              </div>
            </div>
          </div>
        </div>

        <div v-if="isVideo()" :class="`${flex} mt-4 flex-col z-10`">
          <VideoComponent
            :data="currentMaterial?.file"
            :idVideo="currentMaterial?.file.id"
            :startTime="time"
            :isAdaptativeLearning="isAdaptativeLearning"
            ref="videoComponent"
          />
        </div>
        <div v-if="isImage()" :class="`${flex} mt-4`">
          <Image
            :src="currentMaterial?.file.url"
            alt="material-image"
            imageClass="w-full h-[100%] sm:h-[600px] lg:h-[600px] object-cover"
            preview
          />
        </div>
        <div v-if="isAudio()" :class="`${flex} mt-4`">
          <audio
            id="material-audio"
            :src="currentMaterial.file.url"
            class="w-full h-[100%] sm:h-[600px] lg:h-[600px]"
          ></audio>
        </div>
        <div v-if="isPdf()" :class="`${flex} mt-4`">
          <PDFComponent :url="currentMaterial?.file.url" />
        </div>
      </div>

      <div
        class="p-8 w-full h-[100%] sm:h-[600px] lg:h-[600px]"
        v-if="materials[0]?.file?.status != 'DONE'"
      >
        <EmptyData
          :data="materials[0]?.file?.status != 'DONE'"
          :title="`${
            materials[0]?.file?.status === 'WAITING'
              ? $t('objects.empty.status.waiting')
              : $t('objects.empty.status.fail')
          }`"
          :label="`${
            materials[0]?.file?.status === 'WAITING'
              ? $t('objects.empty.status.waitingLabel')
              : $t('objects.empty.status.failLabel')
          }`"
          :image="'waiting_object.svg'"
          imgSize="h-40"
        />
      </div>
    </section>

    <section v-if="!loader && isVideo()" class="col-span-12">
      <div v-if="hasTranscripts">
        <Transcripts
          :material="currentMaterial"
          @onNeedsToPause="needsToPause"
          @onClickDuration="onClickDuration"
        />
      </div>
    </section>

    <Dialog
      v-model:visible="showAlert"
      :draggable="false"
      :breakpoints="{ '960px': '95vw', '640px': '95vw' }"
      :style="{ width: '25vw', minWidth: '360px' }"
      modal
    >
      <template #header>
        <section class="flex items-center gap-3">
          <i class="pi pi-info-circle !text-3xl text-h-warning-400"></i>
          <h3>
            {{ $t("labels.generic", { pt: `Alerta`, en: `Alert` }) }}
          </h3>
        </section>
      </template>
      <p
        class="text-xl"
        v-html="
          'O material do tipo <b>vídeo só será considerado concluído</b>, se o aluno <b>assistir pelo menos 90%</b> de seu conteúdo.'
        "
      ></p>
    </Dialog>
  </main>
</template>

<script lang="ts">
import { MaterialType, TypeModalHeader } from "@/models/material.model";
import { MotionEnter, MotionInitial } from "@/models/motion.model";
import { User } from "@/models/user.model";
import { GenericsUtils } from "@/utils/generics.util";
import { getUserFromStorage } from "@/utils/user-store.util";
import { CourseStudentService } from "@/views/CourseStudent/course-student.service";
import { defineAsyncComponent, defineComponent, PropType } from "vue";

const HistoryMaterials = defineAsyncComponent(
  () => import("./HistoryMaterials/history-materials.vue")
);
const HeaderTeacherMaterials = defineAsyncComponent(
  () => import("./HeaderMaterials/header-teacher-materials.vue")
);
const HeaderLearningMapStudent = defineAsyncComponent(
  () => import("./HeaderMaterials/header-learning-map-student.vue")
);
const Transcripts = defineAsyncComponent(
  () => import("./Transcripts/transcripts.vue")
);

export default defineComponent({
  name: "MaterialLoad",
  emits: [
    "onChooseMaterial",
    "onChangeMaterial",
    "onVerifyMaterials",
    "onCheckVideoEnded",
    "onClickDuration",
    "onGoToEditObject",
    "onDeleteObject",
    "onNextMaterial",
    "onBackMaterial",
  ],
  components: {
    HistoryMaterials,
    HeaderTeacherMaterials,
    HeaderLearningMapStudent,
    Transcripts,
  },
  computed: {
    generics(): GenericsUtils {
      return new GenericsUtils();
    },
    service(): CourseStudentService {
      return new CourseStudentService();
    },
    user(): any {
      return getUserFromStorage();
    },
  },
  props: {
    currentMaterial: {
      type: Object as PropType<any>,
    },
    materials: {
      type: Array as PropType<any>,
    },
    done: {
      type: Boolean,
    },
    learningObjective: {
      type: Object as PropType<any>,
      default: {},
    },
    indexMaterial: {
      type: Number,
      default: 0,
    },
    maxIndexMaterial: {
      type: Number,
      default: 1,
    },
    typeModalHeader: {
      type: String,
    },
    hasTranscripts: {
      type: Boolean,
      default: false,
    },
    isAdaptativeLearning: {
      type: Boolean,
      default: true,
    },
    isDisableBackButton: {
      type: Boolean,
      default: true,
    },
    isDisableNextButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      flex: "w-[100%] min-w-[360px] min-h-[300px] flex justify-center" as string,
      loader: false as boolean,
      startTime: 0 as number,
      showMap: false as boolean,
      showAlert: false as boolean,
      initialMotion: new MotionInitial(0, 0, 0),
      enterMotion: new MotionEnter(),
      time: 0 as number,
      _typeModalHeader: TypeModalHeader,
    };
  },
  watch: {
    currentMaterial() {
      this.loader = true;
      this.checkMaterialType();
      setTimeout(() => (this.loader = false), 800);
    },
  },
  mounted() {
    if (localStorage.getItem("alert-shown") === "yes") return;
    if (
      !this.done &&
      this.isVideo() &&
      (this.user as User).role === "STUDENT"
    ) {
      this.showAlert = true;
      localStorage.setItem("alert-shown", "yes");
    }
  },

  methods: {
    getMaterialColor(type: string): string {
      if (type == MaterialType.ESSENTIAL) {
        type = "bg-h-primary-500";
      } else if (type == MaterialType.COMPLEMENTARY) {
        type = "bg-orange-500";
      } else {
        type = "bg-gray-100";
      }
      return type;
    },
    getMaterialName(type: string): string {
      if (type == MaterialType.ESSENTIAL) {
        type = "Obrigatório";
      } else if (type == MaterialType.COMPLEMENTARY) {
        type = "Complementar";
      } else {
        type = "Outro";
      }
      return type;
    },
    onChooseMaterial(index: number): void {
      this.$emit("onChooseMaterial", index);
    },
    checkMaterialType(): void {
      this.isImage();
      this.isVideo();
      this.isAudio();
      this.isPdf();
    },
    isImage(): boolean {
      return (
        this.currentMaterial?.file?.mimetype == "png" ||
        this.currentMaterial?.file?.mimetype == "jpg" ||
        this.currentMaterial?.file?.mimetype == "jpeg" ||
        this.currentMaterial?.file?.mimetype == "svg"
      );
    },
    isVideo(): boolean {
      return (
        this.currentMaterial?.file?.mimetype == "mp4" ||
        this.currentMaterial?.file?.mimetype == "x-mpegURL"
      );
    },
    isAudio(): boolean {
      return this.currentMaterial?.file?.mimetype == "mp3";
    },
    isPdf(): boolean {
      return this.currentMaterial?.file?.mimetype == "pdf";
    },
    needsToPause(value: boolean): void {
      (this.$refs["videoComponent"] as any).needsToPause(value);
    },
    studentMap(value: boolean = false): void {
      this.showMap = value;
    },
    onVerifyMaterials(value: number): void {
      this.$emit("onVerifyMaterials", value);
    },
    onOpenFeedback(feedbackType: string): void {
      this.$emit("onCheckVideoEnded", feedbackType);
    },
    onNextMaterial(): void {
      this.$emit("onNextMaterial");
    },
    onClickDuration(event: any): void {
      this.time = event;
      this.$emit("onClickDuration");
    },
    onGoToEditObject(): void {
      this.$emit("onGoToEditObject");
    },
    onDeleteObject() {
      this.$emit("onDeleteObject");
    },
    isDisabledBackButton(): boolean {
      if (this.isAdaptativeLearning) return this.indexMaterial == 0;
      return this.isDisableBackButton;
    },
  },
});
</script>
